'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFailed = exports.isSucceeded = exports.isStarted = exports.isOutOfSync = exports.isUninitialized = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _asyncStatuses = require('../constants/asyncStatuses');

var _getters = require('./getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isStatus = (0, _curry2.default)(function (status, asyncData) {
  return (0, _getters.getStatus)(asyncData) === status;
});

/**
 * Predicate to determine if an async status is uninitialized
 * @param {AsyncData}
 * @returns {Boolean}
 */
var isUninitialized = exports.isUninitialized = isStatus(_asyncStatuses.UNINITIALIZED);

/**
 * Predicate to determine if an async status is out of sync
 * @param {AsyncData}
 * @returns {Boolean}
 */
var isOutOfSync = exports.isOutOfSync = isStatus(_asyncStatuses.OUT_OF_SYNC);

/**
 * Predicate to determine if an async status is started
 * @param {AsyncData}
 * @returns {Boolean}
 */
var isStarted = exports.isStarted = isStatus(_asyncStatuses.STARTED);

/**
 * Predicate to determine if an async status is succeeded
 * @param {AsyncData}
 * @returns {Boolean}
 */
var isSucceeded = exports.isSucceeded = isStatus(_asyncStatuses.SUCCEEDED);

/**
 * Predicate to determine if an async status is failed
 * @param {AsyncData}
 * @returns {Boolean}
 */
var isFailed = exports.isFailed = isStatus(_asyncStatuses.FAILED);